import Column from 'canvas-core-react/lib/Column';
import TextBody from 'canvas-core-react/lib/TextBody';
import TextHeadline from 'canvas-core-react/lib/TextHeadline';
import React from 'react';
// ICONS
import { ReactComponent as Icon1 } from '../icons/icon_infobanner_1.svg';
// STYLES
import './Banner.scss';

const Banner = () => {
	const text_1 = '¡Tenemos esta increíble oportunidad para ti!';
	const text_2 = 'Invierte con una tasa exclusiva por tiempo limitado';
	const text_3 = 'Haz crecer tu dinero con Scotia de forma sencilla y segura';

	return (
		<>
		<Column lg={12} xs={4} sm={12} className="banner">
			<Column lg={2.5} md={2.5} className="infobanner_container_icon">
				<div className="Infobanner_v1">
						<div className="infobanner_content">
							<div className='infobanner_v1'>
								<Icon1 />
							</div>
					</div>
				</div>
			</Column>
			<Column lg={9.5} md={9.5} xs={4} className="infobanner_container_text">
				<div className="Infobanner">
					<div className="infobanner_container">
						<div className="infobanner_content">

							<div className='infobanner_v1'>
								<div className='infobanner_v1_1'>
									<TextBody className='infobanner_v1_title infobanner_v1_title0' component="p" type='1'>{text_1}</TextBody><div className='infobanner_br'><br/></div>
									<TextHeadline className='infobanner_v1_title infobanner_v1_title1' component="h1" size='extraSmall'>{text_2}</TextHeadline><div className='infobanner_br'><br/></div>
									<TextBody className='infobanner_v1_title infobanner_v1_title2' component="p" type='1'>{text_3}</TextBody>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Column>
			</Column>
		</>

	)
}

export default Banner;